module.exports = __webpack_public_path__ + "img/4705.14bec023.png";